var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`silkSprite-${_vm.tabNo} harness`,style:(`background-image: url('https://1ae2v478chfucobmr4slnqs1d6.silks.betmakers.com/${_vm.externalMeetingId}_${_vm.raceNumber}_SPRITE_32x32.png')`)})
}
var staticRenderFns = []

export { render, staticRenderFns }